import React from "react";

const SearchBar = ({
  search,
  update,
  onKeyUp,
  submitSearch,
  placeholder,
  searched,
  clearSearch,
  disabled,
  videos,
}) => (
  <label className={`search-bar ${videos && "video-search-bar"}`}>
    {search && (
      <i className="fa-solid fa-xmark" role="button" onClick={clearSearch}></i>
    )}

    <input
      placeholder={placeholder}
      value={search}
      onChange={update}
      onKeyUp={onKeyUp}
      disabled={disabled}
    />
  </label>
);

export default SearchBar;
